import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Modal from '@Components/Common/Modal';
import TX from '@Components/Common/Text';
import Button from '@Components/Common/Button';

const NoticeDeleteAchievementModal = ({
  isNoticeDeleteModalVisible,
  achievementId,
  handleIsNoticeDeleteModalVisible,
  handleDeleteAchievementClick,
}) => {
  return (
    <Modal visible={isNoticeDeleteModalVisible} handleCloseButtonClick={handleIsNoticeDeleteModalVisible}>
      <ModalContentContainer>
        <DeleteText>업적을 삭제할까요?</DeleteText>
      </ModalContentContainer>

      <ModalButtonContainer>
        <Button text="취소" textColor="#0A0A0A" backgroundColor="#F2F2F3" onClick={handleIsNoticeDeleteModalVisible} />
        <Button text="삭제" onClick={() => handleDeleteAchievementClick(achievementId)} />
      </ModalButtonContainer>
    </Modal>
  );
};

NoticeDeleteAchievementModal.propTypes = {
  isNoticeDeleteModalVisible: PropTypes.bool.isRequired,
  achievementId: PropTypes.number,
  handleIsNoticeDeleteModalVisible: PropTypes.func.isRequired,
  handleDeleteAchievementClick: PropTypes.func.isRequired,
};

NoticeDeleteAchievementModal.defaultProps = {
  achievementId: null,
};

const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 96px;
`;

const DeleteText = styled(TX.BodyM)`
  color: ${({ theme }) => theme.colors.ui_on_2};
`;

const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 0px 12px;
  margin-top: 16px;
`;

export default NoticeDeleteAchievementModal;
